import { call, put } from "redux-saga/effects";
import { AdminWalletResponse } from "reduxStore/dataTypes";
import { fetchAdminWallet } from "services/apiService";
import {
  adminWalletFailure,
  adminWalletRequest,
  adminWalletSuccess,
} from "../reducers/adminWalletReducer";

function* adminWalletSaga(
  action: any
): Generator<any, void, AdminWalletResponse | any> {
  try {
    const { payload } = action;
    yield put(adminWalletRequest());
    const response = yield call(fetchAdminWallet, payload);
    yield put(adminWalletSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(adminWalletFailure(error.response));
    } else {
      yield put(adminWalletFailure(error.message));
    }
  }
}

export default adminWalletSaga;
